module.exports = __webpack_public_path__ + "172c882d3148a821bf70245dcd75b0cd.svg";